import { z } from 'zod';

export const AttemptModeSchema = z.enum(['instruction', 'training', 'test', 'final_test']);
export type AttemptMode = z.infer<typeof AttemptModeSchema>;

export const AttemptStatusSchema = z.enum(['in_progress', 'passed', 'failed', 'abandoned']);
export type AttemptStatus = z.infer<typeof AttemptStatusSchema>;

export const StepEventSchema = z.object({
  stepId: z.string().uuid(),
  // What happened at this step.
  outcome: z.enum(['correct_first_try', 'self_corrected', 'feedback_recovered', 'wrong']),
  timestamp: z.string().datetime(),
  // Optional details (region id picked, value entered, drag target).
  detail: z.record(z.unknown()).optional(),
});
export type StepEvent = z.infer<typeof StepEventSchema>;

export const AttemptSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  chapterId: z.string().uuid(),
  mode: AttemptModeSchema,
  status: AttemptStatusSchema,
  events: z.array(StepEventSchema).default([]),
  startedAt: z.string().datetime(),
  finishedAt: z.string().datetime().nullable(),
  score: z.object({
    firstAttemptCorrect: z.number().int().min(0),
    selfCorrected: z.number().int().min(0),
    feedbackRecovered: z.number().int().min(0),
    totalSteps: z.number().int().min(0),
  }).nullable(),
});
export type Attempt = z.infer<typeof AttemptSchema>;
